import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../button";


export default function DepositCategory() {
  const router = useNavigate();
  const { appointment_id } = useParams();
  const handleClick = (type) => {
    router(type);

  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(to right, #1f1c2c, #928dab)",
    fontFamily: "Arial, sans-serif",
  };

  const titleStyle = {
    fontSize: "32px",
    color: "#140d0dff",
    marginBottom: "40px",
  };

  const buttonWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  };

  return (
    <div >
      <h1 style={titleStyle}>Crypto Options</h1>
      <div style={buttonWrapperStyle}>

        <Button label="Deposit USDT TRC20" onClick={() => handleClick("/crypto_payment/usdttrc20/" + appointment_id)} />
        <Button label="Deposit USDT ERC20" onClick={() => handleClick("/crypto_payment/usdterc20/" + appointment_id)} />
        <Button label="Deposit BTC" onClick={() => handleClick("/crypto_payment/btc/" + appointment_id)} />
        {/* <Button label="Deposit Transactions" onClick={() => handleClick("/deposit_history")} /> */}
      </div>
    </div>
  );
}
